import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { reduxForm } from 'redux-form';

import ModalWrapper from 'components/Modals/ModalWrapper';
import CustomerAccountInput from 'components/Common/Inputs/CustomerAccountInput';

import { getStorageSetting } from 'actions';

const CrossClientCloneModal = ({ isOpen, onClose, onSubmit }) => {
  const [client, setClient] = useState(null);
  const [copySupportingDocs, setCopySupportingDocs] = useState(false);
  const clients = getStorageSetting('clients') || [];
  // eslint-disable-next-line no-unused-vars
  const sourceForm = useSelector(state => state.forms.crossClientCloneForm);
  const error = useSelector(state => state.forms.crossClientCloneFormError);
  const isCloningForm = useSelector(state => state.forms.isCloningForm);

  const [customerAccountSelections, setCustomerAccountSelections] = useState({
    customer: null,
    customerId: null,
    accounts: [],
    accountId: null,
    legalEntities: [],
    newCustomer: false,
    newAccount: false
  });

  const onClientChange = (e) => {
    const selectedClient = clients.find(c => c.key === parseInt(e.target.value, 10));
    setClient(selectedClient);
    setCustomerAccountSelections(null);
  };

  const disableSubmit = () => {
    const clientEntered = client?.key > 0;
    const selectionValid = customerAccountSelections !== null ? customerAccountSelections.selectionValid : false;
    return isCloningForm || !clientEntered || selectionValid !== true;
  };

  return (
    <ModalWrapper
      isOpen={ isOpen }
      onCancel={ onClose }
      onConfirm={ () => onSubmit({ ...customerAccountSelections, client, copySupportingDocs }) }
      title={ `Clone ${ sourceForm?.formTypeDescription } Form from ${ sourceForm.clientName }` }
      btnConfirmTitle="Submit"
      btnCancelTitle="Cancel"
      disableConfirm={ disableSubmit }
      modalSize="cross-client-clone-modal modal-allow-overflow"
    >
      <form id="cross-client-clone-form" className="form-horizontal">
        <div className="clone-form-selection">
          <div className="form-group col-sm-12">
            <div className="col-4 col-sm-12">
              <label htmlFor="clientId" className="form-label text-right">Target Client *</label>
            </div>
            <div className="col-4">
              <select
                id="client-id"
                name="clientId"
                placeholder="Select Client..."
                className="form-select"
                onChange={ onClientChange }
              >
                <option value="">Select Client...</option>
                { clients.map(c => <option key={ c.key } value={ c.key }>{ c.value }</option>) }
              </select>
            </div>
            <div className="col-4" />
          </div>
        </div>
        { client?.key > 0 && <div className="clone-form-selection">
          <CustomerAccountInput
            clientId={ client ? client.key : null }
            onSelectionChange={ setCustomerAccountSelections }
          />
        </div> }
        <div className="clone-form-selection">
          <div className="columns">
            <div className="col-4" />
            <div className="col-4">
              <label className="form-checkbox">
                Copy supporting docs to the target customer?
                <input
                  type="checkbox"
                  id="cb-copy-supporting-docs"
                  name="copySupportingDocs"
                  value="true"
                  checked={ copySupportingDocs }
                  onChange={ e => setCopySupportingDocs(e.target.checked) }
                />
                <i className="form-icon" />
              </label>
            </div>
          </div>
        </div>
        { error && <div className="error-wrapper">
          <div className="toast toast-error">
            { error.message }
          </div>
        </div> }
      </form>
    </ModalWrapper>
  );
};

CrossClientCloneModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

const CrossClientCloneReduxForm = reduxForm({
  form: 'crossCloneForm',
})(CrossClientCloneModal);

export default CrossClientCloneReduxForm;
